"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Event format for client FE
 * Event format api module. describe manager api for configuration and users
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTypeEnum = void 0;
/**
    * @export
    * @enum {string}
    */
var FieldTypeEnum;
(function (FieldTypeEnum) {
    FieldTypeEnum["Jdate"] = "JDATE";
    FieldTypeEnum["InvitationCode"] = "INVITATION_CODE";
    FieldTypeEnum["Jnumber"] = "JNUMBER";
    FieldTypeEnum["Gender"] = "GENDER";
    FieldTypeEnum["Jfile"] = "JFILE";
    FieldTypeEnum["Jtext"] = "JTEXT";
    FieldTypeEnum["JmultiText"] = "JMULTI_TEXT";
    FieldTypeEnum["Mail"] = "MAIL";
    FieldTypeEnum["Phone"] = "PHONE";
    FieldTypeEnum["Address"] = "ADDRESS";
    FieldTypeEnum["Place"] = "PLACE";
    FieldTypeEnum["Custom"] = "CUSTOM";
    FieldTypeEnum["Privacy"] = "PRIVACY";
    FieldTypeEnum["Invitation"] = "INVITATION";
    FieldTypeEnum["Password"] = "PASSWORD";
    FieldTypeEnum["NumbersRange"] = "NUMBERS_RANGE";
    FieldTypeEnum["DatesRange"] = "DATES_RANGE";
    FieldTypeEnum["AttributeList"] = "ATTRIBUTE_LIST";
    FieldTypeEnum["UniqueId"] = "UNIQUE_ID";
    FieldTypeEnum["JsingleValueSelect"] = "JSINGLE_VALUE_SELECT";
    FieldTypeEnum["JmultipleValueSelect"] = "JMULTIPLE_VALUE_SELECT";
    FieldTypeEnum["Status"] = "STATUS";
    FieldTypeEnum["JloyaltyCode"] = "JLOYALTY_CODE";
    FieldTypeEnum["Email"] = "EMAIL";
})(FieldTypeEnum = exports.FieldTypeEnum || (exports.FieldTypeEnum = {}));
